import { Component, Input, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'skl-insert-user-panel-list',
    templateUrl: 'insert-user-panel-list.component.html',
    imports: [NgTemplateOutlet]
})
export class InsertUserPanelListComponent {

    @Input() public content!: TemplateRef<any>;
}
